(() => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;

    const header = toggle.closest('[data-site-header]');
    if (!header) return;

    const isOpen = header.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('change', (event) => {
    const variantInput = event.target.closest('[data-variant-radio]');
    if (!variantInput) return;

    const form = variantInput.closest('form');
    if (!form) return;

    const button = form.querySelector('[data-product-submit]');
    if (!button) return;

    if (variantInput.dataset.available === 'false') {
      button.disabled = true;
      button.textContent = button.dataset.soldOutText || 'Uitverkocht';
      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.addText || button.textContent;
  });
})();
